import { Helmet } from "react-helmet";
import PolicyLayout from "../sections/policy/policyLayout";
import termsNConditions from '../data/termsNConditions.json';

const TermsNConditionsPage = () => {
    <Helmet>
        <title>Terms of Service</title>
        <meta name="description" content="Learn with Cuddles terms and conditions by Edliena. Read our simple rules that keep the game safe, fun, and enjoyable for every little learner, parent, and teacher." />
        <meta name="keywords" content="Learn with Cuddles terms and conditions, Edliena terms, kids learning rules, educational game agreement, safe play guidelines, parental information, user terms, fair use policy" />
        <link rel="canonical" href="https://cuddles.edliena.com/terms-and-conditions" />
    </Helmet>

    return (
        <>
            <PolicyLayout data={termsNConditions}/>
        </>
    );
}

export default TermsNConditionsPage;